module.exports = __webpack_public_path__ + "static/media/moloch__meme--trans15.e75d7216.png";